module.exports = __webpack_public_path__ + "img/api-gateway.ffdb25af.svg";